import { render, staticRenderFns } from "./fastApprove.vue?vue&type=template&id=71561b9a&scoped=true"
import script from "./fastApprove.vue?vue&type=script&lang=js"
export * from "./fastApprove.vue?vue&type=script&lang=js"
import style0 from "./fastApprove.vue?vue&type=style&index=0&id=71561b9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71561b9a",
  null
  
)

export default component.exports